import { useState, useEffect } from "react";

import {
  getTreatzSpaReservationDetail,
  IResTreatzSpaReservationDetail,
} from "@src/api/treatzSpa/treatzSpa";
import { closeWebview } from "@src/utils/route";
import toast from "@src/utils/toast";
import { TreatzSpaProduct } from "./define";

import DataSection from "@src/components/form/dataSection/DataSection";
import { CustomHeader } from "@src/shared/src";

export default function TreatzSpaCompletion(props: { reservationId: number }) {
  const [reservationDetail, setReservationDetail] = useState<IResTreatzSpaReservationDetail | null>(
    null,
  );

  useEffect(() => {
    getReservationDetailFromServer(props.reservationId);
  }, [props.reservationId]);

  async function getReservationDetailFromServer(reservationId: number) {
    try {
      const res: IResTreatzSpaReservationDetail =
        await getTreatzSpaReservationDetail(reservationId);

      const productName = TreatzSpaProduct[res.productName].name;
      setReservationDetail({
        ...res,
        productName: productName,
      });
    } catch (error) {
      console.error("Error fetching reservation detail:", error);
      toast.error("예약 상세 정보를 가져오는 중 오류가 발생했습니다.");
    }
  }

  return (
    <div className="treatz-spa-completion-page">
      <CustomHeader
        scrollHide={false}
        actionItems={[
          {
            name: "close",
            isIcon: true,
            callback: () => closeWebview(),
          },
        ]}
      />
      <DataSection title={`짝짝짝!\n방문 예약 신청이\n완료되었습니다.`} titleSize="giant" />
      <p className="success-text">
        신청해주신 내용은 트리츠스파에서 확인 후 안내 예정입니다.
        <br />
        <br />
        감사합니다.
      </p>

      {reservationDetail !== null && (
        <div className="summary-wrap">
          <div className="summary-box">
            <p className="summary-title">신청 내역</p>

            <div className="summary-row">
              <p className="summary-label">방문일시</p>
              <p className="summary-value">{reservationDetail.visitDate}</p>
            </div>
            <div className="summary-row">
              <p className="summary-label">예약 인원수</p>
              <p className="summary-value">{reservationDetail.numberOfVisitors}명</p>
            </div>
            <div className="summary-row">
              <p className="summary-label">이용 상품</p>
              <p className="summary-value">{reservationDetail.productName}</p>
            </div>
          </div>
        </div>
      )}

      <button className="btn btn-red500 btn-fixed-circle" onClick={closeWebview}>
        확인
      </button>
    </div>
  );
}
